"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSupported = exports.HMSMediaStreamConstraints = exports.HMSClientConfig = exports.HMSPeer = exports.HMSClient = exports.Stream = exports.LocalStream = exports.Client = void 0;
const client_1 = require("./client");
exports.Client = client_1.default;
const stream_1 = require("./stream");
Object.defineProperty(exports, "LocalStream", { enumerable: true, get: function () { return stream_1.LocalStream; } });
Object.defineProperty(exports, "Stream", { enumerable: true, get: function () { return stream_1.Stream; } });
const hms_client_1 = require("./hms_client");
exports.HMSClient = hms_client_1.default;
Object.defineProperty(exports, "HMSMediaStreamConstraints", { enumerable: true, get: function () { return hms_client_1.HMSMediaStreamConstraints; } });
const hms_peer_1 = require("./hms_peer");
exports.HMSPeer = hms_peer_1.default;
const hms_config_1 = require("./hms_config");
exports.HMSClientConfig = hms_config_1.default;
const Bowser = require("bowser");
const isSupported = () => {
    // TODO replace with firebase
    const browser = Bowser.getParser(window.navigator.userAgent);
    const isValidBrowser = browser.satisfies({
        // TODO add precise versions after checking with browserstack
        windows: {
            'internet explorer': '>10',
            safari: '>9999',
            chrome: '>57',
            firefox: '>52',
            opera: '>44',
        },
        linux: {
            safari: '>9999',
            chrome: '>57',
            firefox: '>52',
            opera: '>44',
        },
        macos: {
            safari: '>9999',
            chrome: '>57',
            firefox: '>52',
            opera: '>44',
        },
        ios: {
            safari: '>9999',
            firefox: '>9999',
            opera: '>9999',
            chrome: '>9999',
        },
        android: {
            safari: '>9999',
            chrome: '>57',
            firefox: '>52',
            opera: '>44',
        },
    });
    return isValidBrowser;
};
exports.isSupported = isSupported;
